const status = {
  APPROVED: 'APPROVED',
  INVISIBLE: 'INVISIBLE',
  DISABLED: 'DISABLED',
  PENDING: 'PENDING', // tutors only
  GRADUATED: 'GRADUATED',
  QUIT: 'QUIT',
  DEACTIVATED: 'DEACTIVATED',
  REJECTED: 'REJECTED', // tutors only
  ACTIVE: 'ACTIVE',
  VOLUNTEER: 'VOLUNTEER', // clients only
  BLOCKED: 'BLOCKED',
  DELETED: 'DELETED', // shared
  IDLE: 'IDLE', // tutors only
  GUEST: 'GUEST' // guest users only
}

const studentStatus = [
  status.ACTIVE,
  status.BLOCKED,
  status.DELETED,
  status.VOLUNTEER
]

const tutorStatus = [
  status.APPROVED,
  status.INVISIBLE,
  status.DISABLED,
  status.PENDING,
  status.GRADUATED,
  status.QUIT,
  status.REJECTED,
  status.BLOCKED,
  status.DELETED,
  status.IDLE
]

const authenticationSteps = { CREDENTIALS: 'CREDENTIALS', DETAILS: 'DETAILS' }

const TYPES = {
  STUDENT: 'student',
  PARENT: 'parent',
  TUTOR: 'tutor',
  ADMIN: 'admin'
}

export default {
  STATUS: status,
  TUTOR_STATUS: tutorStatus,
  STUDENT_STATUS: studentStatus,
  STEPS: authenticationSteps,
  TYPES
}
